// Web renderer for react-native-vector-icons/Ionicons. Renders the real glyph
// from the Ionicons glyphmap using the 'Ionicons' web font (loaded via @font-face
// in web/index.full.web.js). Ionicons is the only family the app uses.
import React from 'react'
import { Text } from 'react-native-web'
import glyphMap from 'react-native-vector-icons/glyphmaps/Ionicons.json'

const Icon = React.forwardRef((props, ref) => {
  const { name, size = 20, color = '#000', style, ...rest } = props
  const code = glyphMap[name]
  const char = typeof code === 'number' ? String.fromCodePoint(code) : ''
  return (
    <Text
      ref={ref}
      {...rest}
      style={[
        { fontFamily: 'Ionicons', fontSize: size, color, lineHeight: size },
        style,
      ]}
    >
      {char}
    </Text>
  )
})
Icon.loadFont = async () => {}
Icon.hasIcon = (name) => glyphMap[name] != null
Icon.getImageSource = async () => null
Icon.getImageSourceSync = () => null
Icon.getRawGlyphMap = () => glyphMap
Icon.getFontFamily = () => 'Ionicons'
Icon.Button = Icon

export default Icon
